import { ClientUserContactType } from "@/Contracts/Clients";

export const isContactTypeDisabled = (
	selectedCompanyId: string | null,
	selectedClientHasContacts: boolean | null,
	activeTabContactType: ClientUserContactType | null,
	isLoading: boolean
): boolean =>
	(selectedCompanyId !== null && selectedClientHasContacts === false) ||
	(activeTabContactType != null &&
		activeTabContactType === ClientUserContactType.PrimaryContact) ||
	isLoading;

export const getDefaultContactType = (
	activeTabContactType: ClientUserContactType | null,
	clientId: string | null
): ClientUserContactType | "" =>
	activeTabContactType ||
	(!clientId ? ClientUserContactType.PrimaryContact : "");

export const getContactTypeForClient = (
	clientUserCount: number
): {
	hasContacts: boolean;
	contactType: ClientUserContactType;
} => ({
	hasContacts: clientUserCount > 0,
	contactType:
		clientUserCount > 0
			? ClientUserContactType.SecondaryContact
			: ClientUserContactType.PrimaryContact
});

export const getEffectiveClientId = (
	clientId: string | null,
	selectedCompanyId: string | null
): string | null => clientId || selectedCompanyId;

export const incrementClientCount = <
	T extends { id: string; client_user_count: number }
>(
	clients: T[],
	clientId: string
): T[] =>
	clients.map(c =>
		c.id === clientId
			? { ...c, client_user_count: c.client_user_count + 1 }
			: c
	);

export const lookupClientFromInitialClients = <
	T extends { id: string; client_user_count: number }
>(
	initialClients: T[],
	selectedValue: string,
	fallbackClient: T | undefined
): T | undefined =>
	initialClients.find(c => c.id === selectedValue) ?? fallbackClient;
